import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import AiToolTemplateV2 from '../../AiToolTemplate/AiToolTemplateV2';
import { 
  createComponentConfig, 
  createComponentItem,
  COMPONENT_TYPES,
  PROMPT_STRATEGIES,
  TOOL_IDS
} from '../../AiToolTemplate/config/componentConfig';

const IdPhotoGeneration = () => {
  const { t } = useI18n();

  // 创建证件照生成的配置
  const idPhotoConfig = createComponentConfig({
    components: [
      createComponentItem({
        type: COMPONENT_TYPES.IMAGE_UPLOAD,
        id: 'sourceImage',
        title: t('idPhotoGeneration.uploadImage'),
        description: t('idPhotoGeneration.uploadImageDescription'),
        promptTemplate: ', based on the reference image',
        required: true,
        props: {
          acceptedFormats: ['jpg', 'jpeg', 'png', 'gif', 'webp'],
          maxSize: 10 * 1024 * 1024, // 10MB
          preview: true,
          cropAspectRatio: null,
          placeholder: t('idPhotoGeneration.clickOrDragUpload')
        },
        order: 1
      }),
      createComponentItem({
        id: 'size',
        type: COMPONENT_TYPES.SIZE_SELECTOR,
        title: t('aiWorkbench.aspectRatio'),
        required: true,
        defaultValue: 'Auto',
        order: 2
      }),
      createComponentItem({
        id: 'idType',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'idType',
          allowMultiple: false
        },
        order: 3
      }),
      createComponentItem({
        id: 'idBackground',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'idBackground',
          allowMultiple: false
        },
        order: 4
      }), 
      createComponentItem({
        id: 'idAttire',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'idAttire',
          allowMultiple: false
        },
        order: 5
      }),
      // createComponentItem({
      //   type: COMPONENT_TYPES.PARAMETER_SELECTOR,
      //   id: 'photoSize',
      //   title: t('idPhotoGeneration.photoSize'),
      //   description: t('idPhotoGeneration.photoSizeDescription'),
      //   required: false,
      //   defaultValue: 'oneInch',
      //   props: {
      //     options: [
      //       { 
      //         value: 'oneInch', 
      //         label: t('idPhotoGeneration.sizes.oneInch.name'), 
      //         description: t('idPhotoGeneration.sizes.oneInch.desc') 
      //       },
      //       { 
      //         value: 'twoInch', 
      //         label: t('idPhotoGeneration.sizes.twoInch.name'), 
      //         description: t('idPhotoGeneration.sizes.twoInch.desc') 
      //       },
      //       { 
      //         value: 'passport', 
      //         label: t('idPhotoGeneration.sizes.passport'), 
      //         description: t('idPhotoGeneration.sizes.passportDesc') 
      //       },
      //       { 
      //         value: 'visa', 
      //         label: t('idPhotoGeneration.sizes.visa'), 
      //         description: t('idPhotoGeneration.sizes.visaDesc') 
      //       }
      //     ],
      //     displayType: 'cards'
      //   }
      // }),
      // createComponentItem({
      //   type: COMPONENT_TYPES.PARAMETER_SELECTOR,
      //   id: 'clothingStyle',
      //   title: t('aiToolTemplate.tools.professionalPortrait.clothingStyle'),
      //   description: t('aiToolTemplate.tools.professionalPortrait.clothingStyleDesc'),
      //   required: false,
      //   defaultValue: null, // Default to null (not selected)
      //   props: {
      //     options: [
      //       { value: 'dark_suit', label: t('aiToolTemplate.tools.professionalPortrait.styles.darkSuit') },
      //       { value: 'light_suit', label: t('aiToolTemplate.tools.professionalPortrait.styles.lightSuit') },
      //       { value: 'tuxedo', label: t('aiToolTemplate.tools.professionalPortrait.styles.tuxedo') },
      //       { value: 'shirt', label: t('aiToolTemplate.tools.professionalPortrait.styles.shirt') },
      //       { value: 'polo', label: t('aiToolTemplate.tools.professionalPortrait.styles.polo') },
      //       { value: 'dress', label: t('aiToolTemplate.tools.professionalPortrait.styles.dress') },
      //       { value: 'blazer', label: t('aiToolTemplate.tools.professionalPortrait.styles.blazer') },
      //       { value: 'casual', label: t('aiToolTemplate.tools.professionalPortrait.styles.casual') }
      //     ],
      //     displayType: 'buttons',
      //     allowMultiple: false
      //   },
      //   order: 2 // Insert after photo size selector
      // }),
      // createComponentItem({
      //   type: COMPONENT_TYPES.COLOR_PICKER,
      //   id: 'backgroundColor',
      //   title: t('idPhotoGeneration.backgroundColor'),
      //   description: t('idPhotoGeneration.backgroundColorDescription'),
      //   required: false,
      //   defaultValue: '#ffffff',
      //   props: {
      //     presetColors: ['#ffffff', '#ff0000', '#0000ff', '#f0f0f0'],
      //     allowCustom: true,
      //     showPalette: true
      //   },
      //   order: 3
      // }),
      createComponentItem({
        type: COMPONENT_TYPES.PROMPT_INPUT,
        id: 'supplementaryPrompt',
        title: t('aiToolTemplate.supplementaryPrompt'),
        description: t('aiToolTemplate.supplementaryPromptDescription'),
        required: false,
        props: {
          placeholder: t('aiToolTemplate.enterSupplementaryPrompt')
        },
        order: 6
      })
    ],
    promptConfig: {
      strategy: PROMPT_STRATEGIES.CUSTOM,
      customHandler: (values) => {
        return values.supplementaryPrompt;
      }
    },
    additionalParams: {
      model: 'nano',
      style: 'id-photo'
    }
  });

  return (
    <AiToolTemplateV2
      toolName={t('idPhotoGeneration.toolName')}
      toolIcon="📷"
      toolDescription={t('idPhotoGeneration.toolDescription')}
      config={idPhotoConfig}
      gradientColors={['#667eea', '#764ba2']}
      toolId={TOOL_IDS.ID_PHOTO_GENERATION}
    />
  );
};

export default IdPhotoGeneration;